import React, { useState, useEffect } from 'react';
import styles from './SearchModal.module.scss';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ReactComponent as FlagIcon } from "assets/flag.svg";
import { ReactComponent as CrosshairIcon } from "assets/crosshair.svg";
import { ReactComponent as BlueHouseIcon } from "assets/blueHouse.svg";
import { ReactComponent as BlueFlagIcon } from "assets/blueFlag.svg";
import { ReactComponent as CloseIcon } from "assets/close.svg";
interface ISearchModalProps {
  isOpen: boolean;
  onClose: () => void;
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  suggestions: any[];
  onSuggestionClick: (suggestion: any, isFirstLocation: boolean, currentLocation: boolean) => void;
  firstLocation: boolean;
}

const SearchModal = ({ 
  isOpen, 
  onClose, 
  searchTerm, 
  onSearchChange, 
  suggestions, 
  onSuggestionClick,
  firstLocation
}: ISearchModalProps) => {
  const [currentLocation, setCurrentLocation] = useState<any>(null);

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        setCurrentLocation({
          description: "Current Location",
          place_id: "current_location",
          terms: [
            { value: "Current Location" },
            { value: `${lat.toFixed(6)}, ${lng.toFixed(6)}` }
          ],
          geometry: {
            location: {
              lat,
              lng
            }
          }
        });
      });
    }
  }, []);

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          {firstLocation ? <BlueHouseIcon style={{width: '25px', height: '25px', padding: '10px'}}/>: <BlueFlagIcon style={{width: '25px', height: '25px', padding: '10px'}}/>}
          <input
            type="text"
            value={searchTerm}
            onChange={onSearchChange}
            className={styles.modalSearchInput}
            placeholder={firstLocation ? 'Starting location' : 'End location'}
          />
          {searchTerm && (
            <CloseIcon onClick={() => onSearchChange({target: {value: ''}} as React.ChangeEvent<HTMLInputElement>)} style={{width: '20px', height: '20px', fill: '#8B8B8B'}}/>
          )}
          {!searchTerm&&(
            <div style={{width: '20px', height: '20px'}}></div>
          )
          }
          <span onClick={onClose} 
            className={styles.cancelStyle}
            style={{marginRight: "40px"}}
            >CANCEL</span>
        </div>
        <div className={styles.suggestionsList}>
          {suggestions.length > 0 ? (
            suggestions.map((suggestion, index) => (
              <div
                key={index}
                className={styles.suggestionItem}
                onClick={() => onSuggestionClick(suggestion, firstLocation, false)}
              >
                <div className={styles.suggestionHeader}>{suggestion.terms[0].value}</div>
                <div className={styles.suggestionSubtext}>{suggestion.terms.slice(0, -1).map((term: any) => term.value).join(', ')}</div>
              </div>
            ))
          ) : (
            <div 
              onClick={() => currentLocation && onSuggestionClick(currentLocation, firstLocation, true)} 
              className={styles.noSuggestions}
            >
              <CrosshairIcon  style={{width: '25px', height: '25px', paddingLeft: '10px'}}/> Use current location 
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchModal;